<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="各项配置" name="config">
        <p class="title">党员概括</p>
        <el-form
          label-position="right"
          label-width="120px"
          :model="formData"
          :rules="rules"
          ref="refForm"
        >
          <el-form-item label="正式党员" prop="full_party_member">
            <!-- <el-input type="number" min="0" class="numInput" v-model="formData.full_party_member"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="formData.full_party_member"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="预备党员" prop="probationary_party_member">
            <!-- <el-input type="number" min="0" class="numInput" v-model="formData.probationary_party_member"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="formData.probationary_party_member"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <p class="title">主题学习概括</p>
          <el-form-item label="举办活动次数" prop="activity_nums">
            <!-- <el-input type="number" min="0" class="numInput" v-model="formData.activity_nums"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="formData.activity_nums"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="参与活动人数" prop="take_park_in_nums">
            <!-- <el-input type="number" min="0" class="numInput"  v-model="formData.take_park_in_nums"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="formData.take_park_in_nums"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
        </el-form>
        <!-- 党龄分布 -->
        <p class="title">党龄分布</p>
        <div class="formBox">
          <el-form
            v-for="(
              partyAgeItem, partyAgeIndex
            ) in formData.party_age_distribution"
            :ref="`partyAgeForm${partyAgeIndex}`"
            :key="'partyAge' + partyAgeIndex"
            :model="partyAgeItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item
              label-width="120px"
              label="年龄段："
              prop="age_group"
              class="err_position"
            >
              <el-input
                disabled
                v-model="partyAgeItem.age_group"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label-width="120px"
              label="数量"
              prop="nums"
              class="err_position"
            >
              <!-- <el-input
          type="number" min="0" class="numInput"
            v-model="partyAgeItem.nums"
            style="width: 207px; float: left"
            placeholder="请输入数量"
          ></el-input> -->
              <el-input
                class="numInput"
                style="width: 207px; float: left"
                v-model.number="partyAgeItem.nums"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 党费缴纳情况 -->
        <p class="title">党费缴纳情况</p>
        <div class="formBox">
          <el-form
            v-for="(
              partyFeeItem, partyFeeIndex
            ) in formData.party_fee_payment_status"
            :ref="`partyFeeForm${partyFeeIndex}`"
            :key="'partyFee' + partyFeeIndex"
            :model="partyFeeItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item label-width="120px" label="时间：" prop="time">
              <el-input
                disabled
                v-model="partyFeeItem.year_month"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              >
                <template slot="append">月</template></el-input
              >
            </el-form-item>
            <el-form-item
              label-width="120px"
              label="已缴纳："
              prop="park_settlements"
            >
              <!-- <el-input
          type="number" min="0" class="numInput"
            v-model="partyFeeItem.park_settlements"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input> -->
              <el-input
                class="numInput"
                placeholder="请输入内容"
                style="width: 207px; float: left"
                v-model.number="partyFeeItem.park_settlements"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label-width="120px"
              label="未缴纳："
              prop="park_vacant_area"
            >
              <!-- <el-input
          type="number" min="0" class="numInput"
            v-model="partyFeeItem.park_vacant_area"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input> -->
              <el-input
                class="numInput"
                placeholder="请输入内容"
                style="width: 207px; float: left"
                v-model.number="partyFeeItem.park_vacant_area"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 园区党建活动参与人员活跃统计 -->
        <p class="title">园区党建活动参与人员活跃统计</p>
        <div class="formBox">
          <el-form
            v-for="(
              partyActiveItem, partyActiveIndex
            ) in formData.party_active_statistics"
            :ref="`partyActiveForm${partyActiveIndex}`"
            :key="'partyActive' + partyActiveIndex"
            :model="partyActiveItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item label-width="120px" label="时间：" prop="time">
              <el-input
                disabled
                v-model="partyActiveItem.year_month"
                style="width: 207px; float: left"
                placeholder="请输入内容"
              >
                <template slot="append">月</template></el-input
              >
            </el-form-item>
            <el-form-item
              label-width="120px"
              label="人数："
              prop="park_settlements"
            >
              <!-- <el-input
          type="number" min="0" class="numInput"
            v-model="partyActiveItem.park_settlements"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input> -->
              <el-input
                class="numInput"
                placeholder="请输入内容"
                style="width: 207px; float: left"
                v-model.number="partyActiveItem.park_settlements"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 园区入驻企业党群组织概况 -->
        <p class="title">
          园区入驻企业党群组织概况
          <el-button style="margin-left: 20px" type="text" @click="addOrg"
            >添加党群组织</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(orgItem, orgIndex) in formData.party_org_overview"
            :ref="`orgForm${orgIndex}`"
            :key="'org' + orgIndex"
            :model="orgItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item
              label-width="120px"
              label="党群组织"
              prop="name"
              class="err_position"
            >
              <el-input
                v-model="orgItem.name"
                style="width: 207px; float: left"
                placeholder="请输入党群组织名称"
              >
              </el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="人数：" prop="nums">
              <el-input
                class="numInput"
                style="width: 207px; float: left"
                v-model.number="orgItem.nums"
                placeholder="请输入数量"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
              <i
                v-if="orgIndex != 0"
                @click="delOrg(orgIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>
        <!-- 园区人员分布 -->
        <p class="title">
          园区人员分布
          <!-- <el-button
            style="margin-left: 20px"
            type="text"
            @click="addOrg"
            >添加党群组织</el-button
          > -->
        </p>
        <el-form
          label-position="right"
          label-width="120px"
          :model="formData"
          :rules="rules"
          ref="refForm"
        >
          <el-form-item label="男性人数" prop="man_nums">
            <!-- <el-input type="number" min="0" class="numInput" v-model="formData.full_party_member"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="formData.man_nums"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="女性人数" prop="woman_nums">
            <!-- <el-input type="number" min="0" class="numInput" v-model="formData.probationary_party_member"></el-input> -->
            <el-input
              class="numInput"
              v-model.number="formData.woman_nums"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="formBox" style="max-height: 500px">
          <p class="title" style="font-size: 14px; padding-left: 50px">
            政治面貌
            <el-button style="margin-left: 20px" type="text" @click="addOutlook"
              >添加政治面貌</el-button
            >
          </p>
          <el-form
            v-for="(outlookItem, outlookIndex) in formData.party_member_overview
              .political_outlook"
            :ref="`outlookForm${outlookIndex}`"
            :key="'outlook' + outlookIndex"
            :model="outlookItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item
              label-width="120px"
              label="政治面貌"
              prop="name"
              class="err_position"
            >
              <el-input
                v-model="outlookItem.name"
                style="width: 207px; float: left"
                placeholder="请输入政治面貌名称"
              >
              </el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="人数：" prop="nums">
              <el-input
                class="numInput"
                style="width: 207px; float: left"
                v-model.number="outlookItem.nums"
                placeholder="请输入数量"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
              <i
                v-if="outlookIndex != 0"
                @click="delOutlook(outlookIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
          <p class="title" style="font-size: 14px; padding-left: 50px">
            学历
            <el-button
              style="margin-left: 20px"
              type="text"
              @click="addEducation"
              >添加学历</el-button
            >
          </p>
          <el-form
            v-for="(educationItem, educationIndex) in formData
              .party_member_overview.education"
            :ref="`educationForm${educationIndex}`"
            :key="'education' + educationIndex"
            :model="educationItem"
            :rules="rules"
            :inline="true"
          >
            <el-form-item
              label-width="120px"
              label="学历"
              prop="name"
              class="err_position"
            >
              <el-input
                v-model="educationItem.name"
                style="width: 207px; float: left"
                placeholder="请输入学历"
              >
              </el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="人数：" prop="nums">
              <el-input
                class="numInput"
                style="width: 207px; float: left"
                v-model.number="educationItem.nums"
                placeholder="请输入数量"
                οninput="value=value.replace(/[^0-9]/g,'')"
              ></el-input>
              <i
                v-if="educationIndex != 0"
                @click="delEducation(educationIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>
        <el-form>
          <el-form-item>
            <el-button type="primary" @click="infoSubmit()">保存</el-button>
            <el-button @click="getInfo()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="青年风采" name="youth">
        <el-button size="small" type="primary" @click="youthAdd()"
          >添加</el-button
        >
        <el-table
          :data="youthData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column label="姓名" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.user_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.company_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="职位" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.position }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所获荣誉" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.honors_received }}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 0 ? "青年企业家" : "有为青年" }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="youthSee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="youthEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="youthDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="youthPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="youthSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="youthTotal"
          >
          </el-pagination>
        </div>
        <!-- 满意度添加 -->
        <el-dialog
          :title="youthTitle"
          :visible.sync="youthFormVisible"
          width="800px"
          @click="closeDialog"
          :close-on-click-modal="false"
        >
          <el-form label-width="150px" :model="youthForm" ref="youthForm">
            <el-form-item
              label="类型"
              :rules="{
                required: true,
                message: '请选择类型',
                trigger: 'change',
              }"
            >
              <el-radio-group
                :disabled="youthCz == 'see'"
                v-model="youthForm.type"
              >
                <el-radio :label="1">有为青年</el-radio>
                <el-radio :label="0">青年企业家</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="姓名"
              prop="user_name"
              :rules="{
                required: true,
                message: '请输入姓名',
                trigger: 'blur',
              }"
            >
              <el-input
                :disabled="youthCz == 'see'"
                v-model.number="youthForm.user_name"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="公司名称"
              prop="company_name"
              :rules="{
                required: true,
                message: '请输入公司名称',
                trigger: 'blur',
              }"
            >
              <el-input
                :disabled="youthCz == 'see'"
                v-model.number="youthForm.company_name"
                placeholder="请输入公司名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="职位"
              prop="position"
              :rules="{
                required: true,
                message: '请输入职位',
                trigger: 'blur',
              }"
            >
              <el-input
                :disabled="youthCz == 'see'"
                v-model.number="youthForm.position"
                placeholder="请输入职位"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="企业简历"
              prop="company_desc"
              :rules="{
                required: true,
                message: '请输入企业简历',
                trigger: 'blur',
              }"
            >
              <el-input
                type="textarea"
                :disabled="youthCz == 'see'"
                v-model.number="youthForm.company_desc"
                placeholder="请输入企业简历"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="所获荣誉"
              prop="honors_received"
              :rules="{
                required: true,
                message: '请输入所获荣誉',
                trigger: 'blur',
              }"
            >
              <el-input
                type="textarea"
                :disabled="youthCz == 'see'"
                v-model.number="youthForm.honors_received"
                placeholder="请输入所获荣誉"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="个人简历"
              prop="user_desc"
              :rules="{
                required: true,
                message: '请输入个人简历',
                trigger: 'blur',
              }"
            >
              <el-input
                type="textarea"
                :disabled="youthCz == 'see'"
                v-model.number="youthForm.user_desc"
                placeholder="请输入个人简历"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              size="small"
              @click="closeDialog, (youthFormVisible = false)"
              >关闭</el-button
            >
            <el-button
              v-if="youthCz == 'add'"
              size="small"
              type="primary"
              :loading="loading"
              class="title"
              @click="youthSubmit('youthForm')"
              >添加</el-button
            >
            <el-button
              v-if="youthCz == 'edit'"
              size="small"
              type="primary"
              :loading="loading"
              class="title"
              @click="youthTjEdit('youthForm')"
              >提交编辑</el-button
            >
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="政策列表" name="policy">
        <el-button size="small" type="primary" @click="policyAdd()"
          >添加</el-button
        >
        <el-table
          :data="policyData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column label="政策标题">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="公司名称" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.company_name }}</span>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="policySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="policyEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="policyDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="policyPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="policySize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="policyTotal"
          >
          </el-pagination>
        </div>

        <!-- 满意度添加 -->
        <el-dialog
          :title="policyTitle"
          :visible.sync="policyFormVisible"
          width="800px"
          @click="closeDialog"
          :close-on-click-modal="false"
        >
          <el-form label-width="150px" :model="policyForm" ref="policyForm">
            <el-form-item
              label="政策标题"
              prop="title"
              :rules="{
                required: true,
                message: '请输入政策标题',
                trigger: 'blur',
              }"
            >
              <el-input
                :disabled="policyCz == 'see'"
                v-model.number="policyForm.title"
                placeholder="请输入政策标题"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="政策内容"
              prop="content"
              :rules="{
                required: true,
                message: '请输入政策内容',
                trigger: 'blur',
              }"
            >
              <el-input
                type="textarea"
                :disabled="policyCz == 'see'"
                v-model.number="policyForm.content"
                placeholder="请输入政策内容"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              size="small"
              @click="closeDialog, (policyFormVisible = false)"
              >关闭</el-button
            >
            <el-button
              v-if="policyCz == 'add'"
              size="small"
              type="primary"
              :loading="loading"
              class="title"
              @click="policySubmit('policyForm')"
              >添加</el-button
            >
            <el-button
              v-if="policyCz == 'edit'"
              size="small"
              type="primary"
              :loading="loading"
              class="title"
              @click="policyTjEdit('policyForm')"
              >提交编辑</el-button
            >
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  yzYqdjConfigDetail,
  yzYqdjConfigEdit,
  yzYqdjYouthList,
  yzYqdjYouthDetail,
  yzYqdjYouthEdit,
  yzYqdjYouthDel,
  yzYqdjYouthAdd,
  yzYqdjPolicyList,
  yzYqdjPolicyDetail,
  yzYqdjPolicyEdit,
  yzYqdjPolicyDel,
  yzYqdjPolicyAdd,
} from "@/api/yunzhou";
export default {
  components: {},
  computed: {
    ...mapGetters(["imageOss"]),
  },
  data() {
    return {
      loading: false, //是显示加载
      formData: {
        full_party_member: "21",
        probationary_party_member: "2",
        activity_nums: "1",
        take_park_in_nums: "5",
        party_age_distribution: [
          {
            age_group: "1-5年",
            nums: "",
          },
          {
            age_group: "6-10年",
            nums: "",
          },
          {
            age_group: "10-15年",
            nums: "",
          },
          {
            age_group: "15-20年",
            nums: "",
          },
          {
            age_group: "21-25年",
            nums: "",
          },
          {
            age_group: "26-30年",
            nums: "",
          },
          {
            age_group: "31-35年",
            nums: "",
          },
        ],
        party_fee_payment_status: [
          {
            year_month: "1",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "2",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "3",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "4",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "5",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "6",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "7",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "8",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "9",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "10",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "11",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "12",
            park_settlements: "",
            park_vacant_area: "",
          },
        ],
        party_active_statistics: [
          {
            year_month: "1",
            park_settlements: "",
          },
          {
            year_month: "2",
            park_settlements: "",
          },
          {
            year_month: "3",
            park_settlements: "",
          },
          {
            year_month: "4",
            park_settlements: "",
          },
          {
            year_month: "5",
            park_settlements: "",
          },
          {
            year_month: "6",
            park_settlements: "",
          },
          {
            year_month: "7",
            park_settlements: "",
          },
          {
            year_month: "8",
            park_settlements: "",
          },
          {
            year_month: "9",
            park_settlements: "",
          },
          {
            year_month: "10",
            park_settlements: "",
          },
          {
            year_month: "11",
            park_settlements: "",
          },
          {
            year_month: "12",
            park_settlements: "",
          },
        ],
        party_org_overview: [{ name: "", nums: "" }],
        party_member_overview: {
          sex: {},
          political_outlook: [{ name: "", nums: "" }],
          education: [{ name: "", nums: "" }],
        },
        man_nums: "",
        woman_nums: "",
      },
      rules: {
        man_nums: [{ required: true, message: "请输入人数", trigger: "blur" }],
        woman_nums: [
          { required: true, message: "请输入人数", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        year_month: [
          { required: true, message: "请输入月份", trigger: "blur" },
        ],
        nums: [{ required: true, message: "请输入数量", trigger: "blur" }],
        park_settlements: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        park_vacant_area: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入类型名称",
            trigger: "blur",
          },
        ],
        proportion: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        introduced_projects: [
          { required: true, message: "请输入引进项目数量", trigger: "blur" },
        ],
        completion_rate: [
          { required: true, message: "请输入招商完成率", trigger: "blur" },
        ],
        settlement_rate: [
          { required: true, message: "请输招商入驻率", trigger: "blur" },
        ],
        converted: [
          { required: true, message: "请输入已转化", trigger: "blur" },
        ],
        to_be_converted: [
          { required: true, message: "请输入待转化", trigger: "blur" },
        ],
        year: [{ required: true, message: "请输入年份", trigger: "blur" }],
      },
      activeName: "config",

      youthData: [],
      youthTitle: "添加",
      youthCz: "add",
      youthFormVisible: false,
      youthForm: {},
      youthPage: 1,
      youthTotal: 0,
      youthSize: 15,

      policyData: [],
      policyTitle: "添加",
      policyCz: "add",
      policyFormVisible: false,
      policyForm: {},
      policyPage: 1,
      policyTotal: 0,
      policySize: 15,
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 添加学历
    addEducation() {
      this.formData.party_member_overview.education.push({
        name: "",
        nums: "",
      });
    },
    // 删除学历
    delEducation(index) {
      this.formData.party_member_overview.education.splice(index, 1);
    },
    // 添加政治面貌
    addOutlook() {
      this.formData.party_member_overview.political_outlook.push({
        name: "",
        nums: "",
      });
    },
    // 删除政治面貌
    delOutlook(index) {
      this.formData.party_member_overview.political_outlook.splice(index, 1);
    },
    // 党群组织
    addOrg() {
      this.formData.party_org_overview.push({
        name: "",
        nums: "",
      });
    },
    // 删除党群组织
    delOrg(index) {
      this.formData.party_org_overview.splice(index, 1);
    },

    // 政策列表-详情
    policyInfo(id) {
      yzYqdjPolicyDetail({ id: id }).then((res) => {
        this.policyForm = {
          id: res.data.id,
          title: res.data.title,
          content: res.data.content,
        };
      });
    },
    // 政策列表编辑操作
    policyEdit(val) {
      this.policyTitle = "编辑";
      this.policyCz = "edit";
      this.policyInfo(val.id);
      this.policyFormVisible = true;
    },
    // 政策列表查看操作
    policySee(val) {
      this.policyTitle = "查看";
      this.policyCz = "see";
      this.policyInfo(val.id);
      this.policyFormVisible = true;
    },

    // 政策列表-删除
    policyDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          yzYqdjPolicyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getPolicyList();
          });
        })
        .catch(() => {});
    },
    // 政策列表-新增
    policySubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          yzYqdjPolicyAdd(that.policyForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getPolicyList();
              that.policyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 政策列表-编辑
    policyTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          yzYqdjPolicyEdit(that.policyForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getPolicyList();
              that.policyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 添加政策列表
    policyAdd() {
      this.policyFormVisible = true;
      this.policyTitle = "添加";
      this.policyCz = "add";
      this.policyForm = {
        title: "",
        content: "",
      };
    },
    // 获取政策列表列表
    getPolicyList() {
      let data = {
        page: this.policyPage,
        page_size: this.policySize,
      };
      yzYqdjPolicyList(data).then((res) => {
        this.policyTotal = res.data.total;
        this.policyData = res.data.data;
      });
    },
    // 政策列表分页
    handleSizeChange(val) {
      this.policySize = val;
      this.getPolicyList();
    },
    // 政策列表分页
    handleCurrentChange(val) {
      this.policyPage = val;
      this.getPolicyList();
    },

    // 青年风采-详情
    youthInfo(id) {
      yzYqdjYouthDetail({ id: id }).then((res) => {
        this.youthForm = {
          id: res.data.id,
          user_name: res.data.user_name,
          company_name: res.data.company_name,
          position: res.data.position,
          company_desc: res.data.company_desc,
          honors_received: res.data.honors_received,
          user_desc: res.data.user_desc,
          type: res.data.type,
        };
      });
    },
    // 青年风采编辑操作
    youthEdit(val) {
      this.youthTitle = "编辑";
      this.youthCz = "edit";
      this.youthInfo(val.id);
      this.youthFormVisible = true;
    },
    // 青年风采查看操作
    youthSee(val) {
      this.youthTitle = "查看";
      this.youthCz = "see";
      this.youthInfo(val.id);
      this.youthFormVisible = true;
    },

    // 青年风采-删除
    youthDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          yzYqdjYouthDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getYouthList();
          });
        })
        .catch(() => {});
    },
    // 青年风采-新增
    youthSubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          yzYqdjYouthAdd(that.youthForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getYouthList();
              that.youthFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 青年风采-编辑
    youthTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          yzYqdjYouthEdit(that.youthForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getYouthList();
              that.youthFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 添加青年风采
    youthAdd() {
      this.youthFormVisible = true;
      this.youthTitle = "添加";
      this.youthCz = "add";
      this.youthForm = {
        type: 0,
        user_name: "",
        company_name: "",
        position: "",
        company_desc: "",
        honors_received: "",
        user_desc: "",
      };
    },
    // 获取青年风采列表
    getYouthList() {
      let data = {
        page: this.youthPage,
        page_size: this.youthSize,
      };
      yzYqdjYouthList(data).then((res) => {
        this.youthTotal = res.data.total;
        this.youthData = res.data.data;
      });
    },
    // 青年风采分页
    handleSizeChange(val) {
      this.youthSize = val;
      this.getYouthList();
    },
    // 青年风采分页
    handleCurrentChange(val) {
      this.youthPage = val;
      this.getYouthList();
    },

    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getInfo();
      } else if (tab.index == 1) {
        this.getYouthList();
      } else if (tab.index == 2) {
        this.getPolicyList();
      }
    },
    convertedIup(e) {
      this.formData.to_be_converted = 100 - e.target.value;
    },
    beConvertedIup(e) {
      this.formData.converted = 100 - e.target.value;
    },
    // 获取基础信息
    getInfo() {
      yzYqdjConfigDetail().then((res) => {
        if (res.data.party_summary) {
          this.formData.full_party_member = JSON.parse(
            res.data.party_summary
          ).full_party_member;
          this.formData.probationary_party_member = JSON.parse(
            res.data.party_summary
          ).probationary_party_member;
        }
        if (res.data.party_theme_learning) {
          this.formData.activity_nums = JSON.parse(
            res.data.party_theme_learning
          ).activity_nums;
          this.formData.take_park_in_nums = JSON.parse(
            res.data.party_theme_learning
          ).take_park_in_nums;
        }
        if (res.data.party_age_distribution) {
          this.formData.party_age_distribution = JSON.parse(
            res.data.party_age_distribution
          );
        }
        if (res.data.party_fee_payment_status) {
          this.formData.party_fee_payment_status = JSON.parse(
            res.data.party_fee_payment_status
          );
        }
        if (res.data.party_active_statistics) {
          this.formData.party_active_statistics = JSON.parse(
            res.data.party_active_statistics
          );
        }
        if (res.data.party_org_overview) {
          this.formData.party_org_overview = JSON.parse(
            res.data.party_org_overview
          );
        }
        if (res.data.party_member_overview) {
          let memberData = JSON.parse(res.data.party_member_overview);
          this.formData.man_nums = memberData.sex.man_nums;
          this.formData.woman_nums = memberData.sex.woman_nums;
          this.formData.party_member_overview = {
            education: memberData.education,
            political_outlook: memberData.political_outlook,
          };
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.activityFormVisible = false;
    },
    infoSubmit() {
      console.log(this.formData);
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        this.validateForm("refForm"),
        // 数组部分的表单，用map返回验证函数的调用

        // 党龄分布
        ...this.formData.party_age_distribution.map((item, index) =>
          this.validateForm(`partyAgeForm${index}`)
        ),
        // 党费缴纳情况
        ...this.formData.party_fee_payment_status.map((item, index) =>
          this.validateForm(`partyFeeForm${index}`)
        ),
        // 园区党建活动参与人员活跃统计
        ...this.formData.party_active_statistics.map((item, index) =>
          this.validateForm(`partyActiveForm${index}`)
        ),
        // 园区入驻企业党群组织概况
        ...this.formData.party_org_overview.map((item, index) =>
          this.validateForm(`orgForm${index}`)
        ),
        // 园区入驻企业党群组织概况
        ...this.formData.party_member_overview.political_outlook.map(
          (item, index) => this.validateForm(`outlookForm${index}`)
        ),
        ...this.formData.party_member_overview.education.map((item, index) =>
          this.validateForm(`educationForm${index}`)
        ),
        // this.$nextTick(() => {
        //   that.elFormErrorScrollIntoView();
        // }),
      ]).then((res) => {
        let party_summary = {
          full_party_member: this.formData.full_party_member,
          probationary_party_member: this.formData.probationary_party_member,
        };
        let party_theme_learning = {
          activity_nums: this.formData.activity_nums,
          take_park_in_nums: this.formData.take_park_in_nums,
        };
        let sex = {
          man_nums: this.formData.man_nums,
          woman_nums: this.formData.woman_nums,
        };

        let party_member_overview = {
          sex: sex,
          political_outlook:
            this.formData.party_member_overview.political_outlook,
          education: this.formData.party_member_overview.education,
        };
        let data = {
          party_summary: JSON.stringify(party_summary),
          party_theme_learning: JSON.stringify(party_theme_learning),
          party_age_distribution: JSON.stringify(
            this.formData.party_age_distribution
          ),
          party_fee_payment_status: JSON.stringify(
            this.formData.party_fee_payment_status
          ),
          party_active_statistics: JSON.stringify(
            this.formData.party_active_statistics
          ),
          party_org_overview: JSON.stringify(this.formData.party_org_overview),
          party_member_overview: JSON.stringify(party_member_overview),
        };
        yzYqdjConfigEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getInfo();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          if (res) resolve();
          else reject();
        });
      });
    },
    // 园区税收统计
    addParkTax() {
      this.formData.park_tax_statistics.push({
        year: "",
        nums: "",
      });
    },
    // 删除园区税收统计
    delParkTax(index) {
      this.formData.park_tax_statistics.splice(index, 1);
    },
    // 添加园区营收统计
    addParkRevenue() {
      this.formData.park_revenue_statistics.push({
        type: "",
        proportion: "",
      });
    },
    // 删除园区营收统计
    delParkRevenue(index) {
      this.formData.park_revenue_statistics.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
}
.formBox {
  width: 100%;
  max-height: 300px;
  overflow: auto;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
